module.exports = __webpack_public_path__ + "static/media/studio-step2.d617e543.png";